import React, { Component } from "react";

import HomeNav from './components/HomeNav/HomeNav'
import Intro from "./components/Uvod/intro";
import HomeFooter from "./components/HomeFooter/HomeFooter";
import Info from "./components/Info/Info"   
import CoreTeam from "./components/CoreTeam/coreteam";
import Lectures from "./components/Lectures/lectures";
import Materials from "./components/Materials/materials";
import FancyCounter from "./components/FancyCounter/fancycounter";
import Lbg from "./components/Lbg/lbg";

class Home extends Component {
    render() {
        return(
            <>
            <HomeNav />
            <Intro />
            <Info />
            <CoreTeam />
            <Materials />
            <Lectures />
            <FancyCounter />
            <Lbg />
            <HomeFooter />
            </>
        );
    }
}

export default Home;